"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalLoanSchema = void 0;
var active_loan_schema_1 = require("./active-loan-schema");
var fee_item_schema_1 = require("./fee-item-schema");
var transactional_loan_borrower_schema_1 = require("./transactional-loan-borrower-schema");
var transactional_loan_property_schema_1 = require("./transactional-loan-property-schema");
exports.transactionalLoanSchema = {
    type: 'object',
    required: [
        'transactionalLoanID',
        'accountArchiveTypeCode',
        'cmhcAccountNumber',
        'insuredLoanAccountTypeCode',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        transactionalLoanID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        accountArchiveTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be a number with up to 12 digits',
        },
        insuredLoanAccountTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        loanReactivateDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        activeLoan: active_loan_schema_1.activeLoanSchema,
        borrowers: {
            type: 'array',
            items: transactional_loan_borrower_schema_1.transactionalLoanBorrowerSchema,
        },
        property: transactional_loan_property_schema_1.transactionalLoanPropertySchema,
        feeItem: {
            type: 'array',
            items: fee_item_schema_1.feeItemSchema,
        },
    },
};
